import DOMPurify from 'dompurify';

import { HTML_DRAFT_CSP, htmlDraftSource } from './htmlDraftPreviewPolicy';
export { HTML_DRAFT_MAX_CHARS, HTML_DRAFT_INTERVAL_MS } from './htmlDraftPreviewPolicy';

// A draft is only a visual progress snapshot. Never use the playable preview's
// permissions, interaction bridge, persistence, or download/publish actions.
export function prepareHtmlDraft(html) {
  const source = htmlDraftSource(html);
  if (!source) return '';
  const clean = DOMPurify.sanitize(source, {
    WHOLE_DOCUMENT: true,
    RETURN_DOM: true,
    FORBID_TAGS: ['script', 'noscript', 'iframe', 'frame', 'frameset', 'object', 'embed', 'applet', 'base', 'link', 'meta', 'template', 'portal', 'form', 'audio', 'video', 'source', 'track', 'animate', 'animatemotion', 'animatetransform', 'set', 'foreignobject', 'use'],
    FORBID_ATTR: ['src', 'srcset', 'href', 'xlink:href', 'action', 'formaction', 'poster', 'background', 'autofocus', 'contenteditable', 'tabindex'],
  });
  const body = clean.querySelector('body');
  // Wait for actual content, rather than displaying an empty frame while the
  // model writes CSS or a script. SVG-only illustrations count as content.
  if (!body) return '';
  const content = body.cloneNode(true);
  content.querySelectorAll('style').forEach(style => style.remove());
  if (!content.textContent.trim() && !content.querySelector('svg, img')) return '';
  const head = clean.querySelector('head');
  if (!head) return '';
  const policy = clean.ownerDocument.createElement('meta');
  policy.httpEquiv = 'Content-Security-Policy'; policy.content = HTML_DRAFT_CSP;
  head.prepend(policy);
  const viewport = clean.ownerDocument.createElement('meta');
  viewport.name = 'viewport'; viewport.content = 'width=device-width,initial-scale=1';
  head.append(viewport);
  const reducedMotion = clean.ownerDocument.createElement('style');
  reducedMotion.textContent = '*,*::before,*::after{animation:none!important;transition:none!important;caret-color:transparent!important}html{scroll-behavior:auto!important}';
  head.append(reducedMotion);
  body.setAttribute('inert', '');
  // Preserve sanitized body/html classes, inline styles, direction and language.
  return `<!doctype html>${clean.outerHTML}`;
}
